import { useReducer, useCallback } from 'react'
import { apiRequest } from 'store/Misc/apiRequest'

type State = { data: any; error: any; loading: boolean }
type Action =
    | { type: 'success'; data: any }
    | { type: 'error'; error: any }
    | { type: 'loading'; loading: boolean }

const initialState: State = { data: null, error: null, loading: false }

function reducer(state: State, action: Action): State {
    switch (action.type) {
        case 'success':
            return { ...state, data: action.data, loading: false, error: null }
        case 'error':
            return { ...state, error: action.error, loading: false }
        case 'loading':
            return { ...state, loading: action.loading }
        default:
            return state
    }
}

interface UseMutationProps {
    method: 'post' | 'patch' | 'put'
    url: string
}

interface MutateParams {
    payload: any
    onSuccess: (data: any) => void
    onError: (error: any) => void
}

const useMutation = ({ method, url }: UseMutationProps) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const mutate = useCallback(
        async ({ payload, onSuccess, onError }: MutateParams) => {
            dispatch({ type: 'loading', loading: true })
            try {
                const res = await apiRequest({ method, url, payload, params: {} })
                dispatch({ type: 'success', data: res })
                onSuccess(res)
            } catch (err) {
                dispatch({ type: 'error', error: err })
                onError(err)
            } finally {
                dispatch({ type: 'loading', loading: false })
            }
        },
        [method, url]
    )

    return { ...state, mutate }
}

export default useMutation